import { ellipsis } from "@/common/style/commonStyle";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	itemLabel: {
		color: tokens.colorNeutralForeground3
	},
	itemValue: {
		maxWidth: "330px",
		...ellipsis(),
	}
});
